import { render, staticRenderFns } from "./EmployeesStatistics.vue?vue&type=template&id=d1362d56"
import script from "./EmployeesStatistics.vue?vue&type=script&lang=ts"
export * from "./EmployeesStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports